import {
  createPage as publicCreatePage,
  getPage as publicGetPage,
  updatePage as publicUpdatePage,
  setPageRoute as publicSetPageRoute,
  removePageRoute as publicRemovePageRoute,
  publishPage as publicPublishPage,
  unpublishPage as publicUnpublishPage,
  archivePage as publicArchivePage,
  unarchivePage as publicUnarchivePage,
  schedulePage as publicSchedulePage,
  deletePage as publicDeletePage,
  queryPages as publicQueryPages,
  typedQueryPages as publicTypedQueryPages,
  bulkUpdatePageTags as publicBulkUpdatePageTags,
  bulkUpdatePageTagsByFilter as publicBulkUpdatePageTagsByFilter,
} from './quickpages-v1-page-pages.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  PageQuery,
  PagesQueryBuilder,
  typedQueryPages as universalTypedQueryPages,
} from './quickpages-v1-page-pages.universal.js';

function customQueryPages(httpClient: HttpClient) {
  const router = /*#__PURE__*/ createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryPages(httpClient)(),
    typedQueryFunction: (query: PageQuery) =>
      publicTypedQueryPages(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): PagesQueryBuilder;
  function overloadedQuery(
    query: PageQuery
  ): ReturnType<typeof universalTypedQueryPages>;
  function overloadedQuery(query?: PageQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

/** @internal */
export const createPage: MaybeContext<
  BuildRESTFunction<typeof publicCreatePage> & typeof publicCreatePage
> = /*#__PURE__*/ createRESTModule(publicCreatePage);
/** @internal */
export const getPage: MaybeContext<
  BuildRESTFunction<typeof publicGetPage> & typeof publicGetPage
> = /*#__PURE__*/ createRESTModule(publicGetPage);
/** @internal */
export const updatePage: MaybeContext<
  BuildRESTFunction<typeof publicUpdatePage> & typeof publicUpdatePage
> = /*#__PURE__*/ createRESTModule(publicUpdatePage);
/** @internal */
export const setPageRoute: MaybeContext<
  BuildRESTFunction<typeof publicSetPageRoute> & typeof publicSetPageRoute
> = /*#__PURE__*/ createRESTModule(publicSetPageRoute);
/** @internal */
export const removePageRoute: MaybeContext<
  BuildRESTFunction<typeof publicRemovePageRoute> & typeof publicRemovePageRoute
> = /*#__PURE__*/ createRESTModule(publicRemovePageRoute);
/** @internal */
export const publishPage: MaybeContext<
  BuildRESTFunction<typeof publicPublishPage> & typeof publicPublishPage
> = /*#__PURE__*/ createRESTModule(publicPublishPage);
/** @internal */
export const unpublishPage: MaybeContext<
  BuildRESTFunction<typeof publicUnpublishPage> & typeof publicUnpublishPage
> = /*#__PURE__*/ createRESTModule(publicUnpublishPage);
/** @internal */
export const archivePage: MaybeContext<
  BuildRESTFunction<typeof publicArchivePage> & typeof publicArchivePage
> = /*#__PURE__*/ createRESTModule(publicArchivePage);
/** @internal */
export const unarchivePage: MaybeContext<
  BuildRESTFunction<typeof publicUnarchivePage> & typeof publicUnarchivePage
> = /*#__PURE__*/ createRESTModule(publicUnarchivePage);
/** @internal */
export const schedulePage: MaybeContext<
  BuildRESTFunction<typeof publicSchedulePage> & typeof publicSchedulePage
> = /*#__PURE__*/ createRESTModule(publicSchedulePage);
/** @internal */
export const deletePage: MaybeContext<
  BuildRESTFunction<typeof publicDeletePage> & typeof publicDeletePage
> = /*#__PURE__*/ createRESTModule(publicDeletePage);
/** @internal */
export const bulkUpdatePageTags: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdatePageTags> &
    typeof publicBulkUpdatePageTags
> = /*#__PURE__*/ createRESTModule(publicBulkUpdatePageTags);
/** @internal */
export const bulkUpdatePageTagsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdatePageTagsByFilter> &
    typeof publicBulkUpdatePageTagsByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkUpdatePageTagsByFilter);
export const queryPages: MaybeContext<
  BuildRESTFunction<typeof customQueryPages> & typeof customQueryPages
> = /*#__PURE__*/ createRESTModule(customQueryPages);

export {
  Status,
  Type,
  SortOrder,
  WebhookIdentityType,
} from './quickpages-v1-page-pages.universal.js';
export {
  Page,
  PageOriginOneOf,
  PageRoute,
  ExtendedFields,
  Tags,
  TagList,
  PagePublished,
  PageUnpublished,
  PageArchived,
  PageUnarchived,
  PageScheduled,
  CreatePageRequest,
  CreatePageResponse,
  GetPageRequest,
  GetPageResponse,
  UpdatePageRequest,
  UpdatePageResponse,
  SetPageRouteRequest,
  SetPageRouteResponse,
  RemovePageRouteRequest,
  RemovePageRouteResponse,
  PublishPageRequest,
  PublishPageResponse,
  UnpublishPageRequest,
  UnpublishPageResponse,
  ArchivePageRequest,
  ArchivePageResponse,
  UnarchivePageRequest,
  UnarchivePageResponse,
  SchedulePageRequest,
  SchedulePageResponse,
  DeletePageRequest,
  DeletePageResponse,
  QueryPagesRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryPagesResponse,
  CursorPagingMetadata,
  Cursors,
  BulkUpdatePageTagsRequest,
  BulkUpdatePageTagsResponse,
  ItemMetadata,
  ApplicationError,
  BulkUpdatePageTagsResult,
  BulkActionMetadata,
  BulkUpdatePageTagsByFilterRequest,
  BulkUpdatePageTagsByFilterResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  UpdatePage,
  PublishPageOptions,
  SchedulePageOptions,
  PagesQueryResult,
  PagesQueryBuilder,
  PageQuerySpec,
  BulkUpdatePageTagsOptions,
  BulkUpdatePageTagsByFilterOptions,
} from './quickpages-v1-page-pages.universal.js';
export { utils } from './quickpages-v1-page-pages.universal.js';
export {
  StatusWithLiterals,
  TypeWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  BulkUpdatePageTagsApplicationErrors,
  BulkUpdatePageTagsByFilterApplicationErrors,
  CommonQueryWithEntityContext,
  PageQuery,
} from './quickpages-v1-page-pages.universal.js';
